<template>
  <div v-if="active">
    <Dialog
      :visible.sync="active"
      :modal="true"
      :closable="false"
      :style="{ maxWidth: '90%', width: '60%', minWidth: '450px' }"
    >
      <template #header>
        <h2 class="title is-4 w100 has-text-centered">
          {{ $t("new-conference") }}
          <font-awesome-icon class="close-modal-icon" :icon="['fal', 'times-circle']" @click="close" />
        </h2>
      </template>

      <div>
        <div class="p-fluid p-formgrid p-grid p-justify-center">
          <div class="p-field p-col-6 has-text-centered bold">
            <label for="conference_name">{{ $t("conference-name") }}</label>
            <InputText id="conference_name" v-model="conferenceName" autofocus type="text" required />
          </div>

          <div id="filterBox" class="p-d-flex">
            <div class="p-col p-col-12">
              <div class="title is-5 has-text-centered">
                {{ $t("choose-teams") }}
                <Button
                  class="p-button-text p-button-sm inlineButton"
                  :label="$t('Button.toggle')"
                  @click="toggleTeams"
                />
              </div>

              <div class="">
                <div class="p-col-12 p-d-flex">
                  <div class="p-col-6" v-for="column in teamColumns">
                    <div class="p-field-checkbox p-justify-center" v-for="team in column" :key="team.id">
                      <Checkbox :id="team.name" :name="team.name" :value="team.id" v-model="selectedTeams" />
                      <label :for="team.name"
                        >{{ team.name }} <i>({{ team.division.name }})</i></label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-text-center mt-5">
          <Button @click="save" :disabled="!conferenceName || !selectedTeams.length">{{
            $t("AppMenu.create_button")
          }}</Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    createConference: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      conferenceName: null,
      selectedTeams: [],
    };
  },
  methods: {
    getIDs(group) {
      if (!group) return [];
      return group.map(g => g.id);
    },
    toggleTeams() {
      if (this.selectedTeams.length) {
        this.selectedTeams = [];
      } else {
        this.selectedTeams = this.getIDs(this.teams);
      }
    },
    save() {
      const conference = {
        name: this.conferenceName,
        season_id: this.$store.getters.currentSeason.id,
        team_ids: this.selectedTeams,
      };
      this.conferenceName = null;
      this.selectedTeams = [];
      this.createConference(conference);
    },
  },
  computed: {
    teamColumns() {
      let columns = [];
      let mid = Math.ceil(this.teams.length / 2);
      for (let col = 0; col < 2; col++) {
        columns.push(this.teams.slice(col * mid, col * mid + mid));
      }
      return columns;
    },
  },
};
</script>
